var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c((_vm.icon + "-icon"),{tag:"component",class:{ 'mr-2': _vm.left && !_vm.right, 'ml-2': _vm.right && !_vm.left, 'icon-rotate': _vm.spin },attrs:{"size":_vm.size,"fillColor":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }